
import { SeatIncrement } from '@/types/BillingMultipliers'
import firebase from 'firebase/app'
import Vue from 'vue'

export default Vue.extend({
  name: 'SeatIncrementCard',
  props: {
    value: {
      type: Array as () => SeatIncrement[],
      default: () => [],
    },
    title: {
      type: String,
      default: 'Invalid',
    },
  },
  data() {
    return {
      tableItems: [] as SeatIncrement[],
    }
  },
  mounted() {
    this.tableItems = this.value
  },
  computed: {
    seatIncrementHeaders(): { text: string; value: string; width?: string }[] {
      return [
        {
          text: 'Start range',
          value: 'rangeStart',
        },
        {
          text: 'End range',
          value: 'rangeEnd',
        },
        {
          text: 'Increment',
          value: 'increment',
        },
        {
          text: 'Actions',
          value: 'actions',
        },
      ]
    },
    isAddNewRowBtnDisabled(): boolean {
      return !!this.tableItems.find((tableItem) => !this.isTableItemValid(tableItem))
    },
    unitFieldRules() {
      return [
        (newVal: string) => {
          return parseFloat(newVal) >= 0
        },
      ]
    },
  },
  methods: {
    endRangeRules(startRangeStr: string) {
      return [
        (newVal: string) => {
          const endRange = parseFloat(newVal)
          const startRange = parseFloat(startRangeStr)

          return endRange >= startRange
        },
      ]
    },
    isTableItemValid(tableItem: SeatIncrement): boolean {
      return (
        tableItem.increment >= 0 &&
        tableItem.rangeStart >= 0 &&
        tableItem.rangeEnd >= 0 &&
        tableItem.rangeEnd >= tableItem.rangeStart
      )
    },
    handleChange(id: string, field: keyof SeatIncrement, newVal: string): void {
      this.tableItems = this.tableItems.map((tableItem) => {
        if (tableItem.id === id) return { ...tableItem, [field]: parseFloat(newVal) }
        return tableItem
      })

      const validTableItems = this.tableItems.filter((tableItem) =>
        this.isTableItemValid(tableItem)
      )

      this.$emit('input', validTableItems)
    },
    handleAddNewRow(): void {
      const randomId = firebase.firestore().collection('idGenerator').doc().id

      this.tableItems = [
        ...this.tableItems,
        { id: randomId, rangeStart: -1, rangeEnd: -1, increment: -1 } as SeatIncrement,
      ]
    },
    handleRowDelete(item: SeatIncrement): void {
      this.tableItems = this.tableItems.filter((tableItem) => tableItem.id !== item.id)

      const validTableItems = this.tableItems.filter((tableItem) =>
        this.isTableItemValid(tableItem)
      )

      this.$emit('input', validTableItems)
    },
  },
})
